export default __webpack_public_path__ + "static/media/classButtonImage_eggs.1e6268eb.jpg";